<template>
    <div class="installation-management-software-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Installation Management Software in partnership with Onsite7
                </div>
                <div class="logo">
                    <img src="/images/onsite7-header-logo.png">
                </div>
            </div>
            <div class="highlight-bar">
                <h1>First year free - Use code EPCONNECT365D at checkout</h1>
            </div>
            <div class="box-1">
                <h1>Built by the trade, for the trade</h1>
                <p>
                    We have partnered with industry experts Onsite 7 to offer job management software. As
                    an Epwin Window Systems partner, your company can get one licence free of charge for
                    the first 12 months, a saving of £240 + VAT.
                </p>
                <div>
                    <a href="https://onsite7.co.uk/" target="_blank" class="btn-primary _lg" @click="partnerLinkClicked()">
                        <strong>Visit Onsite 7</strong>
                    </a>
                </div>
            </div>
            <div class="overlapping-image">
              <youtube-embed videoId="tuAr3HyTWrQ"></youtube-embed>
<!--                <vimeo-player ref="player" :video-id="422231979" :options="{ responsive: true }"/>-->
            </div>
            <div class="box-2">
                <p>
                    Onsite 7 is built by the trade for the trade. It gives you a single source of information for
                    every job, domestic or commercial, you work on, including documentation, instructions,
                    photographs, videos and contract variations.
                </p>
                <div>
                    <a href="https://onsite7.co.uk/" target="_blank" class="btn-primary-outline _lg" @click="partnerLinkClicked()">
                        <strong>Visit Onsite 7</strong>
                    </a>
                </div>
            </div>
            <div class="box-3 main _image-left">
                <div class="image">
                    <img src="/images/installer-benefits-landing-page-installation-management-software-3.jpg">
                </div>
                <div class="content">
                    <div>
                        <p>
                            <strong class="txt-primary">
                                Because you can capture detailed documentation, photos and videos from every stage of
                                a job you can:
                            </strong>
                        </p>
                        <ul>
                            <li>
                                Reduce public liability claims.
                            </li>
                            <li>
                                Prevent customer disputes.
                            </li>
                            <li>
                                Reduce financial loss and refunds.
                            </li>
                            <li>
                                Save unnecessary site visits.
                            </li>
                        </ul>
                        <p>
                            <strong class="txt-primary">
                                Because all the information is stored in the cloud you and your team can:
                            </strong>
                        </p>
                        <ul>
                            <li>
                                Access information on-the-go via the mobile app or in the office.
                            </li>
                            <li>
                                Become more efficient in under 14 days.
                            </li>
                            <li>
                                Save time and money every year chasing lost paperwork or making unnecessary
                                site visits.
                            </li>
                        </ul>

                    </div>
                </div>
            </div>
            <div class="box-4">
                <h2>Onsite 7 is a practical solution for every business, no matter what its size</h2>
                <div class="cols">
                    <div class="col">
                        <div class="icon">
                            <i class="fal fa-check"></i>
                        </div>
                        <div class="text">
                            Straightforward and easy to set up.
                        </div>
                    </div>
                    <div class="col">
                        <div class="icon">
                            <i class="fal fa-check"></i>
                        </div>
                        <div class="text">
                            No ongoing storage costs.
                        </div>
                    </div>
                    <div class="col">
                        <div class="icon">
                            <i class="fal fa-check"></i>
                        </div>
                        <div class="text">
                            Easy management of teams, jobs and customers.
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-5 main _image-right">
                <div class="image">
                    <img src="/images/installer-benefits-landing-page-installation-management-software-4.png">
                </div>
                <div class="content">
                    <div>
                        <div>
                            <h2 class="txt-primary">
                                Customer Relationship Management
                            </h2>
                        </div>
                        <p>
                            You can also use Onsite 7 as a Customer Relationship Management system because all
                            your customers’ information, including documents, notes, job information, is stored in
                            one place and accessible from anywhere.
                        </p>
                        <p>
                            There’s also a customer rating feature so you
                            can capture their feedback automatically.
                        </p>
                    </div>
                </div>
            </div>
            <div class="box-6 main _image-left">
                <div class="image">
                    <img src="/images/installer-benefits-landing-page-installation-management-software-2.jpg">
                </div>
                <div class="content">
                    <div>
                        <div>
                            <h2>
                                Structured, yet flexible
                            </h2>
                        </div>
                        <p>
                            Every stage of the customer’s journey can be edited and recorded, including:
                        </p>
                        <ul>
                            <li>
                                Sales Stages
                            </li>
                            <li>
                                Survey/Measurements Stage
                            </li>
                            <li>
                                Installation/construction stage
                            </li>
                            <li>
                                Service/Maintenance stage
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="box-7 main _image-right">
                <div class="image">
                    <img src="/images/installer-benefits-landing-page-installation-management-software-5.png">
                </div>
                <div class="content">
                    <div>
                        <div>
                            <h2 class="txt-primary">
                                Protect your job, protect your business
                            </h2>
                        </div>
                        <p>
                            It will not just help you provide proof of your work quality... it will help you get paid by
                            your customer for the work you have done!
                        </p>
                        <p>
                            <strong class="txt-primary">
                                With Onsite 7 you can:
                            </strong>
                        </p>
                        <ul>
                            <li>
                                Prove you carried out the work to the highest standard
                            </li>
                            <li>
                                Prove work was completed on time
                            </li>
                            <li>
                                Prove the site was left clean and tidy
                            </li>
                            <li>
                                Prove the products are in full working order
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Installation Management Software Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player';

export default {
    props: [
        'logged_in_user',
    ],
    components: {
      vueVimeoPlayer
    },
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like more information on signing up for Onsite7',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 17,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Onsite7 enquiry',
                'value': 'Onsite7 enquiry',
              });

              this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      partnerLinkClicked() {
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 3,
          'description': `Partner Link Clicked - Onsite7`,
        });
        gtag('event', 'partner_link_clicked', {
          'event_category': 'link',
          'event_label': 'Onsite7 partner link clicked',
          'value': 'Onsite7 partner link clicked',
        });
      },
    },
};
</script>
